import type { Inbox } from "@/types/entities/inbox"

export const isBouncedInbox = (inbox: Inbox) =>
  Boolean(inbox.bouncedAt || inbox.bounceType)

export const getDisplayClassification = (inbox: Inbox) => {
  if (isBouncedInbox(inbox)) {
    return "Bounced"
  }
  return inbox.classifications.length > 0
    ? inbox.classifications[inbox.classifications.length - 1]
    : ""
}
